import { render, staticRenderFns } from "./get-started.vue?vue&type=template&id=351d1fb6"
import script from "./get-started.js?vue&type=script&lang=js&external"
export * from "./get-started.js?vue&type=script&lang=js&external"
import style0 from "./get-started.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports